import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';
import { IContentPreviewService } from '../../Infrastructure/CorBase/ServicesFactoryBase';

export class ContentService extends BaseService implements IContentPreviewService {
	constructor() {
		super('/content');
	}

	public getAllByFilter(filter: ContentFilter) {
		return super.getAllByFilterBase(filter);
	}

	public deleteCache(id: number) {
		return this.deleteBase(`${this._resourceName}/delete-cache/${id}`);
	}

	//VaP - spravne by bylo to presunout do vlastni contentsource service, ale jelikoz se jedna pouze o jedinou metodu, tak nevidim problem nechat tuto metodu zde
	public getOriginalFileById(id: number) {
		return super.getFileByIdWithResourceName(id, 'contentsource/original-file');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public getAllByRefreshFilter(filter: ContentFilter) {
		return super.getAllByFilterBase(filter, 'refresh');
	}

	public getRefreshById(id: number) {
		return super.getByIdWithResourceName(id, this._resourceName + '/refresh');
	}
}

export class ContentFilter extends BaseFilter {
	constructor(idTenant?: number | null, isDeleted?: boolean | null, contentTypeIdentifier?: string | null) {
		super();
		this._idTenant = idTenant;
		this._isDeleted = isDeleted;
		this._contentTypeIdentifier = contentTypeIdentifier;
	}

	private _idTenant?: number | null;
	private _isDeleted?: boolean | null;
	private _contentTypeIdentifier?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {}),
			(this._contentTypeIdentifier != null ? { ContentTypeIdentifier: this._contentTypeIdentifier } : {})
		);

		return data;
	};
}